import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import Testimonials from "@/components/Testimonials";
import BudgetCalculator from "@/components/BudgetCalculator";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Legal from "@/components/Legal";
import CookieBanner from "@/components/CookieBanner";
import AdminLeads from "@/components/AdminLeads";
import BlogList from "@/components/BlogList";
import BlogPost from "@/components/BlogPost";

function Landing() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Manifesto />
        <Testimonials />
        <BudgetCalculator />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F6] text-slate-900 antialiased">
      <div className="grain-overlay" aria-hidden />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/aviso-legal" element={<Legal doc="aviso-legal" />} />
          <Route path="/privacidad" element={<Legal doc="privacidad" />} />
          <Route path="/cookies" element={<Legal doc="cookies" />} />
          <Route path="/admin" element={<AdminLeads />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </BrowserRouter>
      <CookieBanner />
      <Toaster position="top-center" richColors />
    </div>
  );
}
